import { render } from "./DrivesAlarmsPositions.vue?vue&type=template&id=581f650c"
import script from "./DrivesAlarmsPositions.vue?vue&type=script&lang=js"
export * from "./DrivesAlarmsPositions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__